var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:_vm.block.id,staticClass:"block-inner"},[_c('header',{ref:"content",domProps:{"innerHTML":_vm._s(_vm.blockContent)},on:{"click":_vm.handleOptionClick,"change":_vm.sendAnswerText}})])}
var staticRenderFns = []

export { render, staticRenderFns }